import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const deviceManagementRoutes = {
  name: 'device-management',
  path: 'device-management',
  component: () => import('./DeviceManagement.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
